import { CurrencyType } from "@brg/api"
import numeral from "numeral"

export interface UseCurrency {
    format?: string

}

export const DEFAULT_FORMAT = '0,0'
export const NO_RATE = '0,0'
export const FLORIN_FORMAT = '0,0.00'

//в дальнейшем можно менять в зависимости от текущей локали/опций
numeral.register('locale', 'gallery', {
    delimiters: {
        thousands: ' ',         //разделитель разрядов
        decimal: '.',           //разделитель целой и дробной части
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number: any) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: ''
        // symbol: '€'
    }
})

numeral.locale('gallery')

export const useCurrency = (props?: UseCurrency) => {
    const {
        format,
    } = props || {}

    /**
     * функция парсинга дробного числа. В случае успеха вернет число иначе undefined
     */
    const parseValue = (value?: string | number) => {
        if((typeof(value) === 'number') || !value) {
            return value
        }
        return numeral.isNumeral(value) ? +value : undefined
    }

    const getFormat = (currencyType?: number) => {
        if(!currencyType) {
            return DEFAULT_FORMAT
        }
        switch(currencyType) {
            case (CurrencyType.RealMoney):
            case (CurrencyType.RUB):
                return FLORIN_FORMAT
            default:
                return DEFAULT_FORMAT
        }
    }

    const prepareValue = (value?: number, currencyType?: number) => {
        if(!currencyType || !value) {
            return value
        }
        switch(currencyType) {
            case (CurrencyType.RealMoney):
            case (CurrencyType.RUB):
                return Math.ceil(value * 100) / 100
            default:
                return Math.ceil(value)
        }
    }

    interface FormatOptions {
        format: string
    }

    const formatValue = (value?: string | number, currencyType?: number, formatOptions?: FormatOptions) => {
        const { format: externalFormat } = formatOptions || {}
        const numberValue = parseValue(value)
        if(!numberValue || (typeof(numberValue) === 'string')) {
            return value
        }
        const usedFormat = externalFormat || getFormat(currencyType)
        return numeral(prepareValue(numberValue)).format(usedFormat)
    }
    return { parseValue, formatValue, getFormat, prepareValue }
}import { CurrencyType } from "@brg/api"
import numeral from "numeral"

export interface UseCurrency {
    format?: string

}

export const DEFAULT_FORMAT = '0,0'
export const NO_RATE = '0,0'
export const FLORIN_FORMAT = '0,0.00'

//в дальнейшем можно менять в зависимости от текущей локали/опций
numeral.register('locale', 'gallery', {
    delimiters: {
        thousands: ' ',         //разделитель разрядов
        decimal: '.',           //разделитель целой и дробной части
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number: any) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: ''
        // symbol: '€'
    }
})

numeral.locale('gallery')

export const useCurrency = (props?: UseCurrency) => {
    const {
        format,
    } = props || {}

    /**
     * функция парсинга дробного числа. В случае успеха вернет число иначе undefined
     */
    const parseValue = (value?: string | number) => {
        if((typeof(value) === 'number') || !value) {
            return value
        }
        return numeral.isNumeral(value) ? +value : undefined
    }

    const getFormat = (currencyType?: number) => {
        if(!currencyType) {
            return DEFAULT_FORMAT
        }
        switch(currencyType) {
            case (CurrencyType.RealMoney):
            case (CurrencyType.RUB):
                return FLORIN_FORMAT
            default:
                return DEFAULT_FORMAT
        }
    }

    const prepareValue = (value?: number, currencyType?: number) => {
        if(!currencyType || !value) {
            return value
        }
        switch(currencyType) {
            case (CurrencyType.RealMoney):
            case (CurrencyType.RUB):
                return Math.ceil(value * 100) / 100
            default:
                return Math.ceil(value)
        }
    }

    interface FormatOptions {
        format: string
    }

    const formatValue = (value?: string | number, currencyType?: number, formatOptions?: FormatOptions) => {
        const { format: externalFormat } = formatOptions || {}
        const numberValue = parseValue(value)
        if(!numberValue || (typeof(numberValue) === 'string')) {
            return value
        }
        const usedFormat = externalFormat || getFormat(currencyType)
        return numeral(prepareValue(numberValue)).format(usedFormat)
    }
    return { parseValue, formatValue, getFormat, prepareValue }
}